var toastr = window.toastr || {};

var stopwatchDocumentClick = function (event) {
	let stopwatch = $(event.target).closest("#stopwatch");
	if (stopwatch.length > 0) return;
	let scope = $("#stopwatch > div").scope();
	scope.$ctrl.timer.add_new = false;
	scope.$ctrl.popupToggle();
};

class StopwatchCtrl {
	constructor($scope, element, $http, $window, $timeout) {
		this.$scope = $scope;
		this.element = element;
		this.http = $http;
		this.window = $window;
		this.timeout = $timeout;
		this.timer = { is_internal_hours: false, add_new: false };
		this.close = $scope.$parent.$ctrl.popupToggle.bind($scope.$parent.$ctrl);

		Object.defineProperty(this, 'tasks', {
			get() { return $scope.$parent.$ctrl.tasks || []; },
			set(tasks) { $scope.$parent.$ctrl.tasks = tasks || []; }
		});

		// Initialize tasks
		this.tasks.forEach(t => this._initTask(t));

		this._lastTick = Date.now();
		this._tickHandle = setInterval(() => this._tick(), 1000);
	}

	_initTask(task) {
		// Track elapsed seconds
		task._elapsedSeconds = task._elapsedSeconds || (task.elapsed_minutes ? task.elapsed_minutes * 60 : 0);
		task._paused = !!task._paused;
        task._lastTick = Date.now();

		// Only define elapsedTime if it doesn't exist (avoid redefinition error)
		if (!Object.getOwnPropertyDescriptor(task, 'elapsedTime')) {
            Object.defineProperty(task, 'elapsedTime', {
                get() {
                    let elapsedTimeInSeconds = 0;
                    // Return pre-calculated time if paused
                    if (this.paused_at) {
                        elapsedTimeInSeconds = this.elapsed_minutes * 60;
                    } else {
                        // elapsed time in minutes = elapsed_minutes (from previous pause) + (current time - started_at)
                        elapsedTimeInSeconds = this.elapsed_minutes * 60 + Math.floor((moment().valueOf() - moment(this.started_at).valueOf()) / 1000);
                    }
                    // calculate hrs, mins, secs
                    let hours = Math.floor(elapsedTimeInSeconds / 3600);
                    let minutes = Math.floor((elapsedTimeInSeconds % 3600) / 60);
                    let seconds = elapsedTimeInSeconds % 60;
                    if (hours === 0 && minutes === 0) {
                        return seconds.toString() + 's ';
                    }
                    if (hours === 0 ) {
                        return minutes.toString() + 'm ';
                    }
                    return hours.toString() + 'h ' + minutes.toString() + 'm ';
                },
                enumerable: true
            });
        }
        if (!Object.getOwnPropertyDescriptor(task, 'elapsedTimeInMinutes')) {
            Object.defineProperty(task, "elapsedTimeInMinutes", {
                get() {
                    let elapsedTimeInMinutes = 0;
                    // Return pre-calculated time if paused
                    if (this.paused_at) {
                        elapsedTimeInMinutes = this.elapsed_minutes;
                    } else {
                        // elapsed time in minutes = elapsed_minutes (from previous pause) + (current time - started_at)
                        elapsedTimeInMinutes = this.elapsed_minutes + Math.floor((moment().valueOf() - moment(this.started_at).valueOf()) / 1000 / 60);
                    }

                    return elapsedTimeInMinutes;
                }
            });
		}

		// Ensure task.name exists
		if (!task.name) {
			task.name = function () {
				if (this.is_internal_hours) return this.internal_project?.project_name || '';
				else return this.project?.project_name + (this.reference ? "<br/><small>" + this.reference.project_name + "</small>" : '');
			};
		}
	}

	_tick() {
		const now = Date.now();
		const deltaSec = Math.floor((now - this._lastTick) / 1000);
		if (deltaSec <= 0) return;
		this._lastTick = now;

		let updated = false;
		this.tasks.forEach(t => {
			if (!t.stopped && !t._paused) {  // ✅ respects _paused
				t._elapsedSeconds += deltaSec;
				updated = true;
			}
		});

		if (updated) {
			try {
				lscache.set('stopwatch_items', this.tasks, 1);
				this.$scope.$applyAsync();
			} catch (e) {}
		}
	}
	_formatTime(seconds) {
		const h = Math.floor(seconds / 3600);
		const m = Math.floor((seconds % 3600) / 60);
		const s = seconds % 60;
		return `${h}h ${m}m ${s}s`;
	}


    /**
     * Pause a task
     * @param task
     */
    pauseTask(task) {
        if (task.paused_at) return;  // Already paused
        this.http
            .put(`/stopwatch/${task.stopwatch_id}/pause`)
            .then(response => {
                if (response && response.status === 200) {
                    task = Object.assign(task, response.data);
                    toastr.info('⏸️ Paused');
                }
            })
            .catch(err => console.error('Failed to update pause:', err));
    }

    resumeTask(task) {
        if (!task.paused_at) return;  // Not paused
        this.http
            .put(`/stopwatch/${task.stopwatch_id}/resume`)
            .then(response => {
                if (response && response.status === 200) {
                    task = Object.assign(task, response.data);
                    toastr.success('▶️ Resumed');
                }
            })
            .catch(err => console.error('Failed to update resume:', err));
    }

	getQueryParam(param, paramValue) {
		return '&' + param + '=' + paramValue;
	}

	stopTaskSave(task) {
		let callback = function () {
			this.close();

			let url = '/timesheet?create_from=timer';
			if (task.internal_project) {
				url += this.getQueryParam("internal_project_id", task.internal_project_id);
				url += this.getQueryParam("internal_project_name", encodeURIComponent(task.internal_project.project_name));
                url += this.getQueryParam("is_internal_hours", 1);
			}
			if (task.project) {
				url += this.getQueryParam("project_id", task.project_id);
				url += this.getQueryParam("project_name", encodeURIComponent(task.project.customer.customer_name + ' - ' + task.project.project_name));
				url += this.getQueryParam("customer_id", task.project.customer_id);
				url += this.getQueryParam("customer_name", task.project.customer.customer_name);
			}
			if (task.reference) {
				url += this.getQueryParam("reference_id", task.reference_id);
				url += this.getQueryParam("reference_name", encodeURIComponent(task.reference.project_name));
			}
			if (task.practice_name) {
				url += this.getQueryParam("practice_id", task.practice_id);
				url += this.getQueryParam("practice_name", encodeURIComponent(task.practice_name));
			}
			url += this.getQueryParam("start_date", task.started_at);
			url += this.getQueryParam("input_effort_min", task.elapsedTimeInMinutes);
			url += this.getQueryParam("user_id", task.created_by);
            url += this.getQueryParam("user_id", task.created_by);
            if (task.description) {
                url += this.getQueryParam("description", encodeURIComponent(task.description));
            }
			this.window.location.href = window.origin + url;
		};
		this.stopTaskDelete(task, callback.bind(this));
	}

    /**
     * Delete a task
     *
     * @param taskToDelete
     * @param callback
     */
	stopTaskDelete(taskToDelete, callback) {
		let ctrl = this;
		this.http
            .delete('/stopwatch/' + taskToDelete.stopwatch_id)
            .then(function (response) {
                if (response && response.status === 200 && response.data.status) {
                    ctrl.timeout(function () {
                        ctrl.tasks.forEach((task, i) => {
                            if (task.stopwatch_id === taskToDelete.stopwatch_id) {
                                ctrl.tasks.splice(i, 1);
                                return false;
                            }
                        });
                        if (callback) callback();
                    });
                }
		    });
	}

	popupToggle() {
		let element = angular.element(this.element).find("#stopwatch-dropdown");
		let visible = element.css("display") !== "none";
		element.toggle();
		if (visible) document.body.addEventListener("click", stopwatchDocumentClick);
		else document.body.removeEventListener("click", stopwatchDocumentClick);
	}

    /**
     * Add a new task
     *
     * @param $ctrl
     */
	addTask($ctrl) {
		if (!this.timer.project_id && !this.timer.internal_project_id) {
			toastr.warning("No project selected");
			return;
		}
		if (this.timer.project_id && !this.timer.reference_id && !this.timer.internal_project_id) {
			toastr.warning("No reference selected");
			return;
		}

		this.http.post('/stopwatch', this.timer).then(response => {
			if (response && (response.status === 200 || response.status === 201) && response.data) {
                this.tasks.push(response.data);

                this.tasks.forEach(t => this._initTask(t));
                toastr.success("⏱️ Timer started");

                // reset timer form
				$ctrl.timer.add_new = false;
                $ctrl.timer.project_id = null;
                $ctrl.timer.reference_id = null;
                $ctrl.timer.internal_project_id = null;
                $ctrl.timer.description = null;

                // Close popup
				this.close();
			}
		});
	}
}

angular.module('kv').component('stopwatch', {
	templateUrl: '/assets/custom/js/directives/stopwatch/stopwatch.html?v=1001111221122220221',
	controller: StopwatchCtrl,
});

StopwatchCtrl.$inject = ["$scope", "$element", "$http", "$window", "$timeout"];